




import {Component, Prop, Vue} from 'vue-property-decorator';
import MoreComponent from './MoreComponent.vue';

@Component({
  components: {
    MoreComponent,
  },
})
export default class MoreThree extends Vue {
  private moreData = {
    pic: {
      height: '5.7rem',
      src: require('@/assets/images/5-3.png'),
    },
    avatarData: {
      avatar: require('@/assets/images/avatar.png'),
      name: 'Star Zhao',
      article: [
        '本来要高铁来南京出差的，同事们强烈要求希望体验我的ES8，于是就开车来了。从上海浦东开到南京全程还是很轻松的，三位乘坐同事' +
        '一致好评。都觉得长途乘坐还是非常舒适的。又比较自由，中午饭点到梅村服务区，人吃饭车加电，下午直接开到南京市里还剩20公里。路' +
        '上有一些堵车，此时还真有一些小恐慌。',
        '然后就是下单第一次一键加电，而且还是在陌生的城市。就在我们在南京蔚来中心品尝南京特制饮品时，加电的小妹妹就来取钥匙了。我还' +
        '真担心剩余的电太少了，会不会影响她操作，她却安慰说，没问题，也就是多冲一会儿的事。坚毅的目光打消了我所有的顾虑。要是我自' +
        '己找，还真没把握在陌生的城市，20公里内找好合适加电的地方。当我们浪到夫子庙准备吃晚饭的时候，小妹妹联系我电已经加好了。车已' +
        '经原地停好，有照片还有温馨的提示。全程就是这么温馨。',
      ],
    },
    title: '在陌生城市不用到处找桩 轻松加电',
    description: `看创始版第304号车主@Star Zhao第一次自驾 600 公里到陌生城市，一键加电如何协助他完成旅行。`,
  };
}
